enum RequestTypeEnum {
  Kindergarten = 1,
  Preschool = 2,
}

export default RequestTypeEnum;
